import type { PjNfMensalStatus } from '@/services/pjNfMensalService'

export const PJ_NF_STATUS_LABELS: Record<PjNfMensalStatus, string> = {
  AGUARDANDO_NF: 'Aguardando NF',
  NF_ENVIADA: 'NF enviada',
  EM_VALIDACAO: 'Em validação',
  APROVADA: 'Aprovada',
  REJEITADA: 'Rejeitada',
  PAGA: 'Paga',
}

export const PJ_NF_STATUS_CLASS: Record<PjNfMensalStatus, string> = {
  AGUARDANDO_NF: 'bg-yellow-500/10 text-yellow-400',
  NF_ENVIADA: 'bg-blue-500/10 text-blue-400',
  EM_VALIDACAO: 'bg-violet-500/10 text-violet-400',
  APROVADA: 'bg-emerald-500/10 text-emerald-400',
  REJEITADA: 'bg-red-500/10 text-red-400',
  PAGA: 'bg-emerald-600/15 text-emerald-300',
}

export function currentCompetencia(): string {
  const now = new Date()
  const y = now.getFullYear()
  const m = String(now.getMonth() + 1).padStart(2, '0')
  return `${y}-${m}`
}

export function formatCompetenciaLabel(competencia: string): string {
  const [y, m] = competencia.split('-')
  const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ]
  const idx = Number(m) - 1
  return idx >= 0 && idx < 12 ? `${months[idx]} / ${y}` : competencia
}

export function formatPjNfPaymentLabel(row: {
  status: PjNfMensalStatus
  pagoEm: string | null
}): string {
  if (row.status === 'PAGA' && row.pagoEm) {
    return `Pago em ${new Date(row.pagoEm).toLocaleDateString('pt-BR')}`
  }
  if (row.status === 'APROVADA') {
    return 'Aprovada — aguardando pagamento'
  }
  if (row.status === 'NF_ENVIADA' || row.status === 'EM_VALIDACAO') {
    return 'Em análise pelo financeiro'
  }
  if (row.status === 'REJEITADA') {
    return 'Rejeitada — reenvie a NF'
  }
  return 'Aguardando envio da NF'
}

export function canPortalSubmitNf(status: PjNfMensalStatus): boolean {
  return status === 'AGUARDANDO_NF' || status === 'REJEITADA'
}

export function shiftCompetencia(competencia: string, delta: number): string {
  const [yStr, mStr] = competencia.split('-')
  const date = new Date(Number(yStr), Number(mStr) - 1 + delta, 1)
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}
